<template>
  <div class="order-evaluation" :class="{ checkapp: platform === 'checkapp' }">
    <section class="evaluation">
      <!-- <div class="greetings">{{ greetings }}</div> -->
      <!-- <div class="star-area">
                <div v-for="item in scoreSet" :key="item.scoreId">
                    <div class="star"
                    :class="{ checked: item.checked }"
                    @click="score(item)"
                    ></div>
                </div>
            </div> -->
      <div class="options">
        <div @click="score(1)" class="item">
          <div>
            <img v-show="!score1Selected" :src="$setPicSize(iconList[0].unSelectedIcon)"/>
            <img v-show="score1Selected" :src="$setPicSize(iconList[0].selectedIcon)" />
          </div>
          <span :class="{'selected': score1Selected}" v-if="scoreSet[0]">{{ scoreSet[0].scoreDesc }}</span>
        </div>
        <div @click="score(2)" class="item">
          <div>
            <img v-show="!score2Selected" :src="$setPicSize(iconList[1].unSelectedIcon)"/>
            <img v-show="score2Selected" :src="$setPicSize(iconList[1].selectedIcon)" />
          </div>
          <span :class="{'selected': score2Selected}" v-if="scoreSet[1]">{{ scoreSet[1].scoreDesc }}</span>
        </div>
        <div @click="score(3)" class="item">
          <div>
            <img v-show="!score3Selected" :src="$setPicSize(iconList[2].unSelectedIcon)"/>
            <img v-show="score3Selected" :src="$setPicSize(iconList[2].selectedIcon)" />
          </div>
          <span :class="{'selected': score3Selected}" v-if="scoreSet[2]">{{ scoreSet[2].scoreDesc }}</span>
        </div>
        <div @click="score(4)" class="item">
          <div>
            <img v-show="!score4Selected" :src="$setPicSize(iconList[3].unSelectedIcon)" />
            <img v-show="score4Selected" :src="$setPicSize(iconList[3].selectedIcon)" />
          </div>
          <span :class="{'selected': score4Selected}" v-if="scoreSet[3]">{{ scoreSet[3].scoreDesc }}</span>
        </div>
        <div @click="score(5)" class="item">
          <div>
            <img v-show="!score5Selected" :src="$setPicSize(iconList[4].unSelectedIcon)" />
            <img v-show="score5Selected" :src="$setPicSize(iconList[4].selectedIcon)" />
          </div>
          <span :class="{'selected': score5Selected}" v-if="scoreSet[4]">{{ scoreSet[4].scoreDesc }}</span>
        </div>
      </div>
      <div class="star-desc">{{ currScore.curScoreDes }}</div>
      <div class="tags">
        <div
          class="opt-item"
          :class="{ selected: item.selected }"
          v-for="item in currScore.options"
          :key="item.id"
          @click="checkOpt(item)"
        >
          {{ item.name }}
        </div>
        <div class="empty"></div>
      </div>
      <div class="comment-area" v-if="currScore.score > 0">
        <textarea
          ref="textArea"
          v-model="comment"
          placeholder="多方位的评价能帮助更多小伙伴"
          @focus="inputFocus"
          @blur="inputBlur"
          @input="descChange"
        ></textarea>
        <!-- <z-cell-group> -->
        <!-- <z-field
          ref="textArea"
          v-model="comment"
          type="textarea"
          placeholder="多方位的评价能帮助更多小伙伴"
          rows="5"
          autosize
          :maxlength="500"
          count-word
          @blur="inputBlur"
        /> -->
      <!-- </z-cell-group> -->
        <span class="desc-length">{{ remainDescLength }}</span>
      </div>
    </section>
  </div>
</template>

<script>
// import { toast } from '../../../native'
import { debounce } from '../../../lib/utils'
// import BottomButton from '../BottomButton/BottomButton'
import { setTimeout } from 'timers'
//import setPicSize from '@zz-app/setPicSize'
// import { Field, CellGroup, Button } from '@zz-common/zz-ui'

const MAX_DESC_LENGTH = 200

export default {
  name: 'ThreeEvaluation',
  components: {
    // BottomButton
    // 'z-cell-group': CellGroup,
    // 'z-field': Field,
    // 'z-button': Button
  },
  props: {
    // 问候语
    greetings: {
      // 种类
      type: String,
      default: ''
    },
    // 评价分值
    scores: {
      type: Array,
      default: () => []
    },
    // 平台
    platform: {
      type: String,
      default: 'zz'
    }
  },
  data() {
    return {
      // 评价列表数组
      scoreSet: [],
      currScore: {}, // 当前选中
      comment: '', // 评论内容
      commentLen: 0, // 评论内容文字长度
      // 评价分对应文字展开描述
      curScoreDes: {
        1: '体验很糟,我要吐槽',
        2: '体验较差，还需改进',
        3: '体验一般,还能更好',
        4: '服务较好，再接再厉',
        5: '服务很棒,值得表扬'
      },
      // 不同评价分值对应的不同的icon图
      iconList: [
        {
          unSelectedIcon: require('../../../assets/img/EvaluateImg/unscore1.png'),
          selectedIcon: require('../../../assets/img/EvaluateImg/score1.png')
        },
        {
          unSelectedIcon: require('../../../assets/img/EvaluateImg/unscore2.png'),
          selectedIcon: require('../../../assets/img/EvaluateImg/score2.png')
        },
        {
          unSelectedIcon: require('../../../assets/img/EvaluateImg/unscore3.png'),
          selectedIcon: require('../../../assets/img/EvaluateImg/score3.png')
        },
        {
          unSelectedIcon: require('../../../assets/img/EvaluateImg/unscore4.png'),
          selectedIcon: require('../../../assets/img/EvaluateImg/score4.png')
        },
        {
          unSelectedIcon: require('../../../assets/img/EvaluateImg/unscore5.png'),
          selectedIcon: require('../../../assets/img/EvaluateImg/score5.png')
        }
      ]

    }
  },
  watch: {
    // 初始化评价星级状态
    scores(newValue) {
      this.scoreSet = newValue.map((s) => {
        const scoreIn = Number(s.score || s.scoreNum)
        return {
          // 评价种类
          score: s.score || s.scoreNum,
          // 评价描述
          scoreDesc: s.scoreDesc,
          curScoreDes: this.curScoreDes[scoreIn],
          options: s.options.map((o) => {
            return {
              id: o.id,
              name: o.name,
              selected: false
            }
          }),
          checked: false
        }
      })
    }
  },
  computed: {
    score1Selected() {
      return this.currScore.score === '1'
    },
    score2Selected() {
      return this.currScore.score === '2'
    },
    score3Selected() {
      return this.currScore.score === '3'
    },
    score4Selected() {
      return this.currScore.score === '4'
    },
    score5Selected() {
      return this.currScore.score === '5'
    },
    remainDescLength() {
      return this.commentLen + '/' + MAX_DESC_LENGTH
    }
  },
  mounted() {
    console.log('adasasds')
    // 节流用户操作
    this.emitSelctChange = debounce(this.emitSelctChange, 100, false)
  },
  methods: {
    $setPicSize(url) {
      return url
    },
    // 返回选择的星星等级和选项id
    getCurSelect() {
      const { score, options = [] } = this.currScore
      const resultInfo = {
        score,
        content: this.comment,
        optionDesc: options
          .filter((opt) => opt.selected)
          .map((opt) => opt.name)
          .join(','),
        optionIds: options
          .filter((opt) => opt.selected)
          .map((opt) => opt.id)
          .join(',')
      }
      return resultInfo
    },
    // 星星点击
    // score (item) {
    //     this.scoreSet.forEach(s => {
    //         if (s.scoreNum) {
    //             if (s.scoreNum <= item.scoreNum) {
    //                 s.checked = true;
    //             } else {
    //                 s.checked = false;
    //             }
    //             return;
    //         }
    //         if (s.score <= item.score) {
    //             s.checked = true;
    //         } else {
    //             s.checked = false;
    //         }
    //     });
    //     this.currScore = item;
    //     this.emitSelctChange();
    //     this.$emit('starClick', item);
    // },
    // 三档点击，但需要模拟星星点击的效果
    score(score) {
      // 从scoreSet中找到点击的item
      let item = {}
      this.scoreSet.forEach((v) => {
        if (Number(v.score) === score) {
          item = v
        }
      })
      this.scoreSet.forEach((s) => {
        if (s.scoreNum) {
          if (s.scoreNum <= item.scoreNum) {
            s.checked = true
          } else {
            s.checked = false
          }
          return
        }
        if (s.score <= item.score) {
          s.checked = true
        } else {
          s.checked = false
        }
      })
      this.currScore = item
      this.emitSelctChange()
      this.$emit('starClick', item)
    },
    // 选项点击
    checkOpt(item) {
      item.selected = !item.selected
      this.emitSelctChange()
      this.$emit('optClick', item)
    },
    // 输入框输入
    descChange(e) {
      if (e.target.value.length > MAX_DESC_LENGTH) {
        e.target.value = e.target.value.slice(0, MAX_DESC_LENGTH)
      }
      this.commentLen = e.target.value.length
      this.emitSelctChange()
    },
    emitSelctChange() {
      this.$emit('refreshSelect', this.getCurSelect())
    },
    inputFocus() {
      this.$emit('inputFocus')
      setTimeout(() => {
        this.$refs.textArea.scrollIntoView()
      }, 300)
    },
    inputBlur() {
      this.$emit('inputBlur')
    }
  }
}
</script>

<style scoped lang="less">
  @import 'Evaluation.less';
</style>
